<script>
    import CaretIcon from "../components/icons/CaretIcon.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";

    export let shift;

    let showData = false;
</script>

<div class="legend py-1 mb-2">
    <button class="btn no-outline d-flex align-items-center justify-content-between w-100 px-0 fs-6"
            on:click={() => showData = !showData}>
        Service Day
        <span class="d-flex align-items-center gap-2">
            {#if shift.is_service_day > 0}
                <span class="text-gray">Yes</span>
            {/if}
            <CaretIcon size="18" strokeWidth="2" expanded={showData}/>
        </span>
    </button>
</div>
{#if showData}
    <div class="form-group">
        <Checkbox label="Is service day" bind:checked={shift.is_service_day}/>
    </div>
    {#if shift.is_service_day == 1}
        <label>Service notes</label>
        <textarea class="form-control" bind:value={shift.service_notes}></textarea>
    {/if}
{/if}